<template>
  <div class="addTourist">
    <div class="box">
      <div class="title">{{ textMapping.Field1 }}</div>
      <div class="input-box">
        <span :class="{ hmt: callbackpath === 'touristhmtplaceorder' }">{{
          textMapping.Field2
        }}</span>
        <input maxlength="50" v-model.trim="name" type="text" :placeholder="textMapping.Field5" />
      </div>
      <div class="input-box item-box">
        <span :class="{ hmt: callbackpath === 'touristhmtplaceorder' }">{{
          textMapping.Field3
        }}</span>
        <div
          v-if="certType === 'id_card'"
          @click="clickSwitch('id_card')"
          class="item"
          :class="{ currentTicket: certType === 'id_card' }"
        >
          身份证
        </div>
        <div
          v-if="certType !== 'id_card'"
          @click="clickSwitch('passport')"
          class="item"
          :class="{ currentTicket: certType === 'passport' }"
        >
          {{ textMapping.Field6 }}
        </div>
        <div
          v-if="certType !== 'id_card'"
          @click="clickSwitch('hkmo_id_card')"
          class="item"
          :class="{ currentTicket: certType === 'hkmo_id_card' }"
        >
          <div>港澳台</div>
          <div>通行证</div>
        </div>
        <div
          v-if="certType !== 'id_card'"
          @click="clickSwitch('prc')"
          class="item"
          :class="{ currentTicket: certType === 'prc' }"
        >
          <div>{{ textMapping.Field7 }}</div>
        </div>
      </div>
      <div class="input-box">
        <span :class="{ hmt: callbackpath === 'touristhmtplaceorder' }">{{
          textMapping.Field4
        }}</span>
        <input
          :maxlength="maxLengList[`${certType}`]"
          v-model.trim="certNo"
          type="text"
          :placeholder="textMapping.Field8"
        />
      </div>
      <!-- <div class="input-box">
        <span>电话号码</span>
        <input v-model.trim="mobile" type="tel" maxlength="11" placeholder="请输入电话号码">
      </div> -->
    </div>
    <ul class="tags">
      <li v-for="item in tagList" @click="changeTag(item)" :key="item.value">
        <img v-if="item.active" src="~@/assets/image/common/common_tick.png" alt="" />
        <img v-else src="~@/assets/image/common/common_unchecked.png" alt="" />
        <div class="describe">
          <div class="describe-title">{{ item.key }}</div>
          <div class="describe-text">{{ item.describe }}</div>
        </div>
      </li>
    </ul>
    <div class="selected">
      <div class="cancel" @click="cancel">{{textMapping.Field9}}</div>
      <div class="determine" @click="clickConfirm">{{textMapping.Field10}}</div>
    </div>
  </div>
</template>

<script>
import { getAddPerson, getUpdataPerson } from "@/service/oftencontact/oftenconaddTourist.js";
// import { textMapping } from "../../../utiles/common";
export default {
  name: "oftenconaddTourist",
  data() {
    return {
      name: "",
      certType: "id_card",
      certNo: "",
      mobile: "",
      updataType: "add",
      id: "",
      defaultIndex: null,
      defaultValue: null,
      contrastCertNo: null,
      tagList: [],
      maxLengList: {
        id_card: process.env.VUE_APP_IDCARD_MAX_LENGTH,
        passport: process.env.VUE_APP_PASSPORT_MAX_LENGTH,
        hkmo_id_card: process.env.VUE_APP_HKMO_IDCARD_MAX_LENGTH,
        prc: process.env.VUE_APP_PRC_MAX_LENGTH
      },
      textMapping: {
        Field1: "游客",
        Field2: "姓名",
        Field3: "证件类型",
        Field4: "证件号码",
        Field5: "请输入姓名",
        Field6: "护照",
        Field7: "外国人永久居留身份证",
        Field8: "请输入证件号码",
        Field9: '取消',
        Field10: '确定'
      },
      callbackpath: ""
    };
  },
  created() {
    this.defaultItem();
    if (this.$route.query.callbackpath === "touristhmtplaceorder") {
      this.textMapping.Field1 = "游客\nVisitor";
      this.textMapping.Field2 = "姓名\nName";
      this.textMapping.Field3 = "证件类型\nType of ID";
      this.textMapping.Field4 = "证件号码\nID number";
      this.textMapping.Field5 = "请输入姓名 Fill your name here";
      this.textMapping.Field6 = "Passport";
      this.textMapping.Field7 = "外国人永久居留身份证PR";
      this.textMapping.Field8 = "请输入证件号 Fill your ID number here";
      this.textMapping.Field9 = "取消 Cancel";
      this.textMapping.Field10 = "确定 Confirm";
    }

    this.callbackpath = this.$route.query.callbackpath;
    this.tagList = this.generateTagList()
  },
  methods: {
    changeTag(item) {
      this.tagList.forEach(v => (v.active = false));
      item.active = true;
    },
    generateTagList() {
      if (this.callbackpath === "touristhmtplaceorder") {
        return [
          {
            key: "学生 student",
            value: "student",
            describe: "7~18岁及全日制本科以下学生",
            active: true
          },
          {
            key: "成人 adult",
            value: "adult",
            describe: "18~59岁",
            active: false
          }
        ];
      }else {
        return [
        {
          key: "学生",
          value: "student",
          describe: "7~18岁及全日制本科以下学生",
          active: true
        },
        {
          key: "成人",
          value: "adult",
          describe: "18~59岁",
          active: false
        }
      ];
      }
    },
    defaultItem() {
      const oftenContacts = JSON.parse(sessionStorage.getItem("oftenContacts"));
      const updataOftenconaddTourist = JSON.parse(
        sessionStorage.getItem("updataOftenconaddTourist")
      );
      if (!updataOftenconaddTourist) {
        if (this.$route.query.needContactIDCard === "false") {
          this.certType = "passport";
        }
        return;
      }
      const index = oftenContacts.findIndex(v => v.id === updataOftenconaddTourist.id);
      if (updataOftenconaddTourist) {
        this.name = updataOftenconaddTourist.name;
        this.certType = updataOftenconaddTourist.certType;
        this.contrastCertNo = this.certNo = updataOftenconaddTourist.certNo;
        this.mobile = updataOftenconaddTourist.mobile;
        this.id = updataOftenconaddTourist.id;
        this.updataType = "modify";
      }
      if (updataOftenconaddTourist.tag !== "un_set") {
        this.$nextTick(() => {
          this.tagList.forEach(
            v => (v.active = v.value === updataOftenconaddTourist.tag ? true : false)
          );
        });
      }
      this.defaultIndex = index;
      this.defaultValue = updataOftenconaddTourist;
    },
    async clickConfirm() {
      const updataType = this.updataType;
      if (!this.name) return this.$toast("请输入姓名");
      // if(!this.$reg.checkName.test(this.name))return this.$toast('姓名请勿填写特殊字符');
      if (!this.certNo) return this.$toast("请输入证件号码");
      if (this.certType === "id_card" && !this.$reg.checkIDCard(this.certNo))
        return this.$toast("身份证号错误");
      if (this.certType === "id_card" && this.$reg.checkIDCard(this.certNo)) {
        this.certNo = this.certNo.toUpperCase();
      }
      if (this.certType === "passport" && !this.$reg.checkPassportNo.test(this.certNo))
        return this.$toast("请输入正确的证件号");
      if (this.certType === "hkmo_id_card" && !this.$reg.checkhkmTPassportNo.test(this.certNo))
        return this.$toast("请输入正确的证件号");
      if (this.certType === "prc" && !this.$reg.checkNewPrcNo(this.certNo))
        return this.$toast("请输入正确的证件号");
      // if(!this.mobile)return this.$toast('请输入电话号码');
      // if(!this.$reg.checkPhone(this.mobile))return this.$toast('电话格式错误');
      let data;
      let createUpdata = {
        userId: JSON.parse(window.localStorage.getItem("userInfo")).userId,
        name: this.name,
        mobile: this.mobile,
        certNo: this.certNo,
        certType: this.certType,
        personType: "traveller",
        certTypes: [this.certType],
        tag: this.tagList.find(v => v.active).value
        // tag: 'un_set',
        // certTypes: ['id_card', 'hkmo_id_card', 'passport', 'guide', 'military_card', 'other']
      };
      const controllerNumber = JSON.parse(window.sessionStorage.getItem("controllerNumber"));
      if (updataType === "add") {
        data = await getAddPerson.call(this, createUpdata);
      } else {
        data = await getUpdataPerson.call(this, Object.assign(createUpdata, { id: this.id }));
        controllerNumber.some(item => {
          return item.orderItemAttr.some(v => {
            if (v.traverllerCerNo === this.contrastCertNo) {
              v.traverllerName = "";
              v.traverllerPhone = "";
              v.traverllerEmail = "";
              v.traverllerCerType = this.certType;
              v.traverllerCerNo = "";
              return true;
            }
          });
        });
      }
      if (data.status === "0") {
        const toastText = updataType === "add" ? "添加成功" : "修改成功";
        const oftenContacts = JSON.parse(sessionStorage.getItem("oftenContacts")) || [];
        const fillInfo = item => {
          item.traverllerName = this.name;
          item.traverllerPhone = this.mobile;
          item.traverllerEmail = "";
          item.traverllerCerType = this.certType;
          item.traverllerCerNo = this.certNo;
        };
        // 无论找到相同，有余位直接返回true
        const active = controllerNumber.some(item => {
          const { metaTicketInfo } = item;
          return item.orderItemAttr.some(v => {
            const ticketTag = this.$getTicketTag(metaTicketInfo.attrInfos);
            const currentTag = this.tagList.find(v => v.active).value;
            if (!v.traverllerCerNo && ticketTag === currentTag) {
              fillInfo(v);
              return true;
            }
          });
        });
        if (updataType === "add") {
          const newContacts = {
            ...data.data,
            active
          };
          oftenContacts.unshift(newContacts);
        } else {
          this.defaultValue = Object.assign(this.defaultValue, createUpdata);
          this.defaultValue.tagName = this.$mappingTagName(this.defaultValue.tag);
          const newContacts = {
            ...this.defaultValue,
            active
          };
          oftenContacts[this.defaultIndex] = newContacts;
        }
        sessionStorage.setItem("oftenContacts", JSON.stringify(oftenContacts));
        sessionStorage.setItem("controllerNumber", JSON.stringify(controllerNumber));
        this.$toast(toastText);
        setTimeout(this.bounceBack, 1500);
      }
    },
    bounceBack() {
      const { callbackpath } = this.$route.query;
      this.$router.push(`/oftencontactlist?callbackpath=${callbackpath}`);
    },
    clickSwitch(certType) {
      this.certType = certType;
    },
    cancel() {
      this.bounceBack();
    }
  },
  watch: {
    certNo: {
      handler(newValue) {
        if (this.certType !== "id_card") return;
        if (!this.$reg.checkIDCard(newValue)) return;
        this.tagList = this.generateTagList();
        const checkAge = this.$reg.checkAge(newValue);
        // 7 - 18
        // 18 - 25
        // 25 - 59
        // 学生
        if (checkAge >= 7 && checkAge <= 18) {
          this.tagList[0].active = true;
          this.tagList.pop();
        }
        // 学生、成人可选
        if (checkAge > 18 && checkAge < 25) {
          this.tagList[0].active = true;
        }
        // 成人
        if (checkAge >= 25 && checkAge < 1000) {
          this.tagList.shift();
          this.tagList[0].active = true;
        }
      },
      immediate: true,
      deep: true
    }
  }
};
</script>

<style scoped lang="less">
.addTourist {
  min-height: 100vh;
  padding-bottom: 1.333333rem + 0.333333rem;
  white-space: nowrap;
}
.hmt {
  white-space: pre-wrap;
  line-height: 0.666667rem !important;
}
.box {
  margin: 0.4rem 0.346667rem 0;
  background: #ffffff;
  border-radius: 0.16rem;
  padding: 0.346667rem;
  line-height: 0.666667rem;
  font-size: 0.373333rem;
  .title {
    font-size: 0.213333rem * 2;
    line-height: 1;
    padding-bottom: 0.066667rem;
  }
  .input-box {
    margin-top: 0.533333rem;
    display: flex;
    align-items: center;
    span {
      width: 6em;
      margin-right: 0.466667rem;
    }
    input {
      flex: 1;
    }
  }
  .item-box {
    align-items: center;
    span {
      height: 1.2rem;
      line-height: 1.2rem;
    }
    .item {
      width: 2.266666rem;
      margin-right: 0.213333rem;
      flex-direction: column;
      border-radius: 0.16rem;
      font-size: 0.373333rem;
      height: 1.2rem;
      line-height: 0.5rem;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid #b9bed1;
      text-align: center;
      white-space: pre-wrap;
      &:nth-child(4) {
        margin-right: 0;
      }
    }
    .currentTicket {
      background: #3b6d9c;
      border: none !important;
      color: #ffffff;
    }
  }
}
.selected {
  position: fixed;
  bottom: 0.666667rem;
  display: flex;
  width: 100%;
  line-height: 1.333333rem;
  padding: 0 0.4rem;
  div {
    flex: 1;
    border-radius: 0.16rem;
    text-align: center;
    font-size: 0.24rem * 2;
    color: #ffffff;
  }
  .cancel {
    background: #a1a6ba;
    margin-right: 0.32rem;
  }
  .determine {
    background: #3b6d9c;
  }
}

.tags {
  display: flex;
  padding: 0.4rem 0.733333rem;
  & > li {
    display: flex;
    margin-left: 1.533333rem;
    &:first-child {
      margin-left: 0;
    }
    img {
      width: 0.453333rem;
      height: 0.453333rem;
    }
    .describe {
      padding-left: 0.133333rem;
      .describe-title {
        width: 0.8rem;
        height: 0.373333rem;
        background: #f1f5f8;
        border-radius: 0.186667rem;
        font-size: 0.24rem;
        color: #3b6d9c;
        line-height: 0.373333rem;
        text-align: center;
        padding: 0 0.16rem;
      }
      .describe-text {
        margin-top: 0.133333rem;
        font-size: 0.266667rem;
        color: #999999;
        line-height: 0.373333rem;
      }
    }
  }
}
</style>
